import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Redirect /api/* to backend (production: member.shrt.ch serves frontend, backend is separate)
if (window.location.pathname.startsWith('/api/')) {
  const backendUrl = 'https://shrt-backend.onrender.com';
  window.location.replace(backendUrl + window.location.pathname + window.location.search);
}

// Remove Emergent badge
const removeEmergentBadge = () => {
  const selectors = [
    '[data-testid*="emergent"]',
    'a[href*="emergent"]',
    'a[href*="Emergent"]',
    'div[class*="emergent"]',
    '.emergent-badge'
  ];
  
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.remove();
    });
  });
  
  // Remove any fixed positioned elements at bottom right that aren't part of our app
  document.querySelectorAll('body > div:not(#root)').forEach(el => {
    if (!el.classList.contains('toaster') && !el.hasAttribute('data-sonner-toaster')) {
      const style = window.getComputedStyle(el);
      if (style.position === 'fixed' && style.bottom !== 'auto' && style.right !== 'auto') {
        el.remove();
      }
    }
  });
};

// Run on load and periodically
setTimeout(removeEmergentBadge, 100);
setTimeout(removeEmergentBadge, 500);
setTimeout(removeEmergentBadge, 1000);
setTimeout(removeEmergentBadge, 2000);

// Also observe DOM changes
const observer = new MutationObserver(removeEmergentBadge);
observer.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        console.log('[App] Service Worker registered');

        // update() rejects if sw.js is briefly unreachable (deploy, offline) — never crash on that
        const safeUpdate = () => registration.update().catch(() => {});

        // Check for updates immediately
        safeUpdate();

        // Check for updates every 5 minutes
        setInterval(safeUpdate, 5 * 60 * 1000);

        // Check on visibility change (app comes back to foreground)
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            safeUpdate();
          }
        });
      })
      .catch((error) => {
        console.log('[App] SW registration failed:', error);
      });
  });
}
